import { IConfigurationSection, ConfigurationSection } from '../configuration/Section';

export interface IUnitsMenuItem extends IConfigurationSection {
    selectedUnitFormat: number;
}

export class UnitsMenuItem extends ConfigurationSection {
    public selectedUnitFormat: number;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IConfigurationSection);
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IUnitsMenuItem);
    constructor(obj?: any) {
        super(obj && obj as IConfigurationSection);
        this.selectedUnitFormat = obj && obj.selectedUnitFormat || 0;
    }
}
